<div class="table-scroll-container">
  <table mat-table class="sticky-header-table" [dataSource]="dataSource" id="materials-table" matSort [matSortActive]="getActiveSortColumn()" [matSortDirection]="getActiveSortDirection()" (matSortChange)="onSortChanged($event)">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
            {{ 'commonPackagingFields.id' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>

    <ng-container matColumnDef="tracking">
      <th mat-header-cell *matHeaderCellDef [hidden]="!displayTrackedColumn"></th>
      <td mat-cell *matCellDef="let element" [hidden]="!displayTrackedColumn">
        <mat-icon *ngIf="element.hasExternalTracking">track_changes</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.tagFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('tags'), possibleTags: getPossibleTags() }"
            type="button">
            {{ 'dataManagement.tags.titleTags' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('tags'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <app-tag-directive [tags]="getTagsFromIds(element.associatedTagIdentifiers)" [maxDisplayed]="2"> </app-tag-directive>
      </td>
    </ng-container>

    <ng-container matColumnDef="articleName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleName') }" type="button">
            {{ 'component.fields.articleName' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleName'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.articleName }}</td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
            {{ 'component.fields.articleNumber' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.articleNumber }}</td>
    </ng-container>

    <ng-container matColumnDef="creationTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.creationDate' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        {{ formatDateToString(element.creationTimestamp) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModificationTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'commonPackagingFields.lastModificationDate' | transloco }}</th>
      <td mat-cell *matCellDef="let element">
        {{ formatDateToString(element.lastModificationTimestamp) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="manufacturerName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('manufacturerName') }" type="button">
            {{ 'material.fields.manufacturer' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturerName'))">filter_alt </mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.manufacturerName }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!isRecyclingBinSelected" mat-icon-button (click)="navigateToMaterial(element)" matTooltip="{{ 'material.editMaterial' | transloco }}" type="button">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="deletePackagingPart([element.id])" matTooltip="{{ 'material.deleteMaterial' | transloco }}" type="button">
          <mat-icon>delete_forever</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select" stickyEnd>
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" (click)="selectAllMaterials()" type="button">
            {{ 'common.buttons.selectAll' | transloco }} <br />
            ({{ selectedMaterialIds.length }})
          </button>
        </div>
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [matTooltipDisabled]="element.isValidForComponent == null || element.isValidForComponent === true"
        matTooltip="{{ 'material.tooltips.materialNotValidForComponent' | transloco }}">
        <mat-checkbox
          [checked]="isMaterialSelected(element)"
          (change)="setMaterialSelected($event.checked, element)"
          [disabled]="element.isValidForComponent != null && element.isValidForComponent === false">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="subRequestStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('subRequestStatus'), categories: getStatusOptions() }">
          {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestStatus'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let element">{{ getSubRequestStatusLabel(subRequestMap?.get(element.id)?.status) | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="showSubRequestComments">
      <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
      <td mat-cell *matCellDef="let element" style="width: 48px">
        <button mat-icon-button type="button" (click)="showSubRequestComments.emit(element.id); $event.stopPropagation()">
          <mat-icon [matBadge]="commentCountMap?.get(element.id)" [matBadgeHidden]="!commentCountMap?.get(element.id)" matBadgeColor="primary" matBadgeSize="small"
            >comment</mat-icon
          >
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="navigateToSubRequest">
      <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
      <td mat-cell *matCellDef="let element" style="width: 48px">
        <button
          [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
          mat-icon-button
          type="button"
          [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
          (click)="navigateToSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>open_in_new</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModifiedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button
          mat-button
          class="filter-button"
          type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: 'lastModifiedAt' }">
          {{ 'dataManagement.dataExchangeRequests.columns.lastModifiedAt' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('lastModifiedAt')">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ getDate(subRequestMap?.get(row.id)?.lastModifiedAt) | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="approveSubRequest">
      <th mat-header-cell *matHeaderCellDef style="width: 100px; text-align: center">{{ 'dataManagement.actions' | transloco }}</th>
      <td mat-cell *matCellDef="let element" style="width: 148px">
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
          [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
          (click)="approveSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
          [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
          (click)="reopenSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>replay</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
          [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
          (click)="withdrawSubRequest.emit(element.id); $event.stopPropagation()">
          <mat-icon>undo</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="gtin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu" [matMenuTriggerData]="{ caller: getCaller('gtin') }" type="button">
            {{ 'material.fields.gtin' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('gtin'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.gtin }}</td>
    </ng-container>

    <ng-container matColumnDef="manufacturingCountry">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('manufacturingCountry'), categories: getManufacturingCountryOptions() }"
            type="button">
            {{ 'material.fields.manufacturingCountry' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturingCountry'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ element.manufacturingCountry }}</td>
    </ng-container>

    <ng-container matColumnDef="totalWeight">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'material.fields.totalWeight' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.totalWeight }}</td>
    </ng-container>

    <ng-container matColumnDef="totalGrammage">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'material.fields.totalGrammage' | transloco }}</th>
      <td mat-cell *matCellDef="let element">{{ element.totalGrammage }}</td>
    </ng-container>

    <ng-container matColumnDef="hasProductImages">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('hasProductImages'), categories: getYesNoOptions() }"
            type="button">
            {{ 'image.productImages' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasProductImages'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ (element.images?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="hasCertificates">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('hasCertificates'), categories: getYesNoOptions() }"
            type="button">
            {{ 'certificate.certificates' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasCertificates'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ (element.certificates?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="hasAdditionalDocuments">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button
            mat-button
            class="filter-button"
            [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
            [matMenuTriggerData]="{ caller: getCaller('hasAdditionalDocuments'), categories: getYesNoOptions() }"
            type="button">
            {{ 'pdf.productPdfs' | transloco }}
            <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('hasAdditionalDocuments'))">filter_alt</mat-icon>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">{{ (element.documents?.length > 0 ? 'common.dictionary.yes' : 'common.dictionary.no') | transloco }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
 [ngClass]="isMaterialSelected(row) ? 'background-highlight' : ''"></tr>

    <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
  </table>

  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
  </div>
</div>

<div class="pagination-row" *ngIf="isPaginatorVisible">
  <button *ngIf="showColumnOrganizer" mat-stroked-button class="column-organizer-button" (click)="openColumnSettingsDialog()" type="button">
    <mat-icon>view_column</mat-icon>
    {{ 'common.buttons.organizeColumns' | transloco }}
  </button>
  <mat-paginator [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"> </mat-paginator>
</div>
